<template>
  <div class="proposal__wrap">
    <div class="section shadow filter__wrap">
      <div>
        <el-button type="text" @click="$router.push('/platform')"
          >人才币规则</el-button
        >
        <el-button type="text" @click="$router.push('/brokerage')"
          >代理规则</el-button
        >
        <el-button type="text" @click="$router.push('/fee')">会员</el-button>
        <el-button type="primary">就业补贴</el-button>
        <el-button type="text" @click="$router.push('/companyrules')"
          >企业邀请规则</el-button
        >
      </div>
    </div>
    <!-- 表格 -->
    <div class="table__wrap">
      <div class="section shadow" style="padding: 10px 50px">
        <template>
          <p class="flex fdfsdf">
            新用户就业补贴规则:
            <el-switch
              v-model="form.data.allowance_open_status"
              active-text="启用活动"
              inactive-text="关闭活动"
              :active-value="1"
              :inactive-value="2"
              @change="handleSwitchChange"
            >
            </el-switch>
          </p>
          <p>
            1、从未获得过会员的账号可在用户端个人中心领取最长30天会员体验服务(每个账号限送1次)
          </p>
          <p>
            2、在体验期若求职成功入职满规定天数可申请就业补贴，就业补贴到账则会员体验结束
          </p>
          <p>3、用户申请入职补贴与找到工作申请退会员费中所入职的企业不可相同</p>
          <p>
            4、若入职天数或补贴金额有修改，则新用户以修改后规则为准，老用户以当时领取时规则为准。
          </p>
        </template>
        <el-form
          ref="elFormDom"
          label-width="80px"
          label-position="right"
          :model="form.data"
          :rules="form.rules"
        >
          <el-row :gutter="40">
            <el-col :span="8">
              <el-form-item prop="allowance_days" label="入职天数">
                <el-input
                  type="age"
                  v-model="form.data.allowance_days"
                  placeholder="请输入入职天数"
                >
                  <span slot="suffix">天</span>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="allowance_amount" label="补贴金额">
                <el-input
                  type="age"
                  v-model="form.data.allowance_amount"
                  placeholder="请输入补贴金额"
                >
                  <span slot="suffix">元</span>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="section shadow" style="padding: 20px; margin-top: 40px">
        <el-row type="flex" justify="center">
          <el-button @click="reset">重置</el-button>
          <el-button
            type="primary"
            :loading="form.loading"
            :disabled="form.loading"
            @click="confirm"
            >确定</el-button
          >
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import VTable from "@/components/VTable";
export default {
  name: "AgentList",
  components: {
    VTable,
  },
  data() {
    return {
      form: {
        loading: false,
        data: {
          allowance_open_status: "1", //补贴活动开启状态：1-开启补贴活动；2-关闭补贴活动；
          allowance_days: "1", //补贴活动限制入职天数
          allowance_amount: "300", //补贴活动补贴金额
        },
        rules: {
          allowance_days: [
            { required: true, message: "入职天数不能为空" },
            // { type: "number", message: "会员费只能输入整数" },
          ],
          allowance_amount: [
            { required: true, message: "补贴金额不能为空" },
            // { type: "number", message: "佣金比例只能输入整数" },
          ],
        },
      },
    };
  },
  created() {
    this.getTable();
  },
  methods: {
    getTable() {
      this.$http
        .get("admin/userAllowance/rules", { params: {} })
        .then((res) => {
          if (res.code === 1) {
            this.form.data = res.data;
            this.form.data.allowance_open_status = Number(
              res.data.allowance_open_status
            );
            this.form.data.allowance_days = Number(res.data.allowance_days);
            this.form.data.allowance_amount = Number(res.data.allowance_amount);
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    handleSwitchChange() {
      this.$http
        .post("admin/userAllowance/setAllowance", {
          is_open: this.form.data.allowance_open_status,
        })
        .then((res) => {
          if (res.code === 1) {
            this.$message.success("设置成功");
          } else {
            this.$message.error(res.msg);
          }
        })
        .finally(() => {
          this.form.loading = false;
        });
    },
    confirm() {
      this.$refs.elFormDom.validate((valid) => {
        if (valid) {
          this.form.loading = true;
          this.$http
            .post("admin/userAllowance/editRules", {
              days: this.form.data.allowance_days,
              amount: this.form.data.allowance_amount,
            })
            .then((res) => {
              if (res.code === 1) {
                this.$message.success("设置成功");
              } else {
                this.$message.error(res.msg);
              }
            })
            .finally(() => {
              this.form.loading = false;
            });
        }
      });
    },
    reset() {
      this.$refs.elFormDom.resetFields();
    },
  },
};
</script>

<style scoped lang="scss">
.flex {
  display: flex;
}
.proposal__wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;

  .filter__wrap {
    padding: 10px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
  }

  .table__wrap {
    flex: 1;
    padding: 0;
    box-sizing: border-box;
  }
}
.fdfsdf {
  justify-content: space-between;
  align-items: center;
}
</style>